"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=tenant.dto.js.map